import { createSvgIcon } from '@mui/material/utils'

const DeleteRecyclingTrash = createSvgIcon(
  <>
    <path d="M6.44009 73.13L0.590088 36.92H31.9501" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M11.6602 36.92L17.5102 73.13" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M57.4702 73.13L63.3202 36.92H31.9502" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M52.2401 36.92L46.3901 73.13" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M2.42017 48.26H13.4302" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M4.25 58.9H15.26" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M5.94019 69.54H16.9502" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M61.53 48.26H50.52" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M59.7002 58.9H48.6902" stroke="#204ECF" strokeMiterlimit="10" />
    <path d="M58.01 69.54H47" stroke="#204ECF" strokeMiterlimit="10" />
    <path
      d="M58.3201 36.92C58.2001 32.46 54.5501 28.87 50.0601 28.87C49.4701 28.87 48.8901 28.93 48.3401 29.05C47.5401 23.26 42.5801 18.8 36.5701 18.8C31.4901 18.8 27.1701 21.99 25.4601 26.47C24.0801 25.43 22.3701 24.81 20.5101 24.81C16.0601 24.81 12.4301 28.33 12.2601 32.74C12.0001 32.71 11.7401 32.68 11.4801 32.68C8.80008 32.68 6.55008 34.47 5.83008 36.91H58.3201V36.92Z"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M45.7998 0.5V1.5C45.7998 6.02 42.1298 9.7 37.5998 9.7H36.5998V8.7C36.5998 4.18 40.2698 0.5 44.7998 0.5L45.7998 0.5Z"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M36.6099 13.62V14.4H35.8299C32.2899 14.4 29.4199 11.53 29.4199 7.99V7.21H30.1999C33.7399 7.21 36.6099 10.08 36.6099 13.62V13.62Z"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M36.6099 9.7V8.7C36.6099 4.17 40.2799 0.5 44.8099 0.5H45.8099"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path d="M36.6099 9.7V24.76" stroke="#204ECF" strokeMiterlimit="10" />
    <path
      d="M24.3999 56.65L23.2899 58.58C21.6099 61.48 23.7099 65.11 27.0599 65.11H29.4199"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M38.8799 51.9L36.7799 48.26C35.0999 45.36 30.9099 45.36 29.2399 48.26L27.1399 51.9"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
    <path
      d="M36.6101 65.1H38.9701C42.3201 65.1 44.4201 61.47 42.7401 58.57L41.6301 56.64"
      stroke="#204ECF"
      strokeMiterlimit="10"
    />
  </>,
  'DeleteRecyclingTrash'
)

export default DeleteRecyclingTrash
